import { InstantConfigSamplingCache } from './instant-config-sampling-cache';
import { InstantConfigValue } from './types';

export interface InstantConfigGroup<T extends InstantConfigValue = InstantConfigValue>
	extends InstantConfigSamplingCache {
	/**
	 * Can be negated.
	 * @default *
	 * @example [ "non-Safari", "Chrome" ]
	 */
	browsers?: string[];

	/**
	 * String to match hostname.
	 * @default *
	 * @example [ "sandbox-adeng01" ]
	 */
	domains?: string[];

	/**
	 * Can be negated.
	 * @default *
	 * @example [ "desktop", "non-smartphone" ]
	 */
	devices?: string[];

	/**
	 * Can be negated.
	 * @default []
	 * @example [ "non-US", "PL-72", "XX-AF" ]
	 */
	regions?: string[];

	/**
	 * @default true
	 */
	value?: T;
}
